import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy, faExchangeAlt, faEye, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge, BButton, BButtonGroup } from "bootstrap-vue";
import { computed } from "vue";
import {} from "@/api/histories.archived";
import localize from "@/utils/localization";
import ExportRecordDOILink from "@/components/Common/ExportRecordDOILink.vue";
import Heading from "@/components/Common/Heading.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArchivedHistoryCard',
    props: {
        history: null
    },
    emits: ["onView", "onSwitch", "onRestore", "onImportCopy"],
    setup(__props, { emit }) {
        const props = __props;
        const canImportCopy = computed(() => props.history.export_record_data?.target_uri !== undefined);
        library.add(faExchangeAlt, faUndo, faCopy, faEye);
        function onViewHistoryInCenterPanel() {
            emit("onView", props.history);
        }
        function onSetAsCurrentHistory() {
            emit("onSwitch", props.history);
        }
        async function onRestoreHistory() {
            emit("onRestore", props.history);
        }
        async function onImportCopy() {
            emit("onImportCopy", props.history);
        }
        return { __sfc: true, props, canImportCopy, emit, onViewHistoryInCenterPanel, onSetAsCurrentHistory, onRestoreHistory, onImportCopy, faCopy, faExchangeAlt, faEye, faUndo, FontAwesomeIcon, BBadge, BButton, BButtonGroup, localize, ExportRecordDOILink, Heading, StatelessTags, UtcDate };
    }
});
